import React, {useEffect, useState} from "react";
import associateServices from "../../../services";
import Loading from "../../../components/loading";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import moment from "moment/moment";
import Big from "big.js";
import InstrumentIcon from "../../../components/instrument-icon";
import StringHelper from "../../../helpers/string-helper";
import {useLocation, useNavigate} from "react-router-dom";
import NoData from "../../../components/no-data";
import stringHelper from "../../../helpers/string-helper";
import store from "../../../reducers/createReducers";
import GLOBAL_ACTIONS from "../../../actions/global-actions";
import AUTHENTICATION_ACTIONS from "../../../actions/authentication-actions";

const BonusModal = (props) => {
    const {handleClose} = props
    const {t, i18n} = useTranslation()
    const currentLanguage = i18n.language; // Get the current language
    const {
        wallets,
    } = useSelector(state => state.authenticationReducer)
    const navigate = useNavigate()
    const [loading, setLoading] = useState(true)
    const [data, setData] = useState({})
    const [reference, setReference] = useState(false)
    const location = useLocation()

    useEffect(() => {
        getBonusDetail()
    }, [reference])

    const getBonusDetail = () => {
        if (reference) {
            setLoading(true)
            associateServices.getBonusDetail({
                id: reference
            }).then(res => {
                setLoading(false)

                if (res?.data?.id) {

                    if (res?.data?.bonus?.model !== 'freespin' && res?.data?.bonus?.model !== 'scatter')
                        res.data.percentage = Big(res?.data?.current || 0).div(Math.min(res?.data?.required || 0, 1)).times(100).toFixed(2)
                    setData(res?.data || {})
                }
            })
        }
    }


    const getParams = (key) => {
        const searchParams = new URLSearchParams(location?.search);
        return searchParams.get(key);
    }


    useEffect(() => {
        const bdy = document.body
        bdy.classList?.add('modal-open')

        const mdl = document.getElementById('gamebet-modal')
        mdl.classList?.add('show')

        mdl.style.display = 'block'
        mdl.style.backgroundColor = 'rgba(0,0,0,.7)'

        setReference(getParams('reference'))

        return () => {
            bdy.classList?.remove('modal-open')
            mdl.classList?.remove('show')

        }
    }, [getParams])

    const handlePlayGame = (walletCurrency, gameCurrency, game) => {
        store.dispatch(GLOBAL_ACTIONS.setSelectedCurrency(gameCurrency))
        const newWallet = wallets?.find(oo => oo.code === walletCurrency)

        if (newWallet) {
            store.dispatch(AUTHENTICATION_ACTIONS.setActiveWallet(newWallet))
            navigate(stringHelper.getLocalizedPath(currentLanguage, `/casino/games/${game.slug}`))
        }
        // store.dispatch(GLOBAL_ACTIONS.setSelectedCurrency(gameCurrency))

    }
    return (

        <div
            className="modal fade"
            id="gamebet-modal"
            onClick={handleClose}
        >

            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal__content" onClick={e => e.stopPropagation()}>

                        <div>
                            {
                                loading ? <Loading/> :

                                    !data?.bonus ? <NoData desc={t('modals.vip.bonus.no-bonus-found')}/> :
                                        data?.bonus?.model === 'freespin' || data?.bonus?.model === 'scatter' ?
                                            <div className="progress-wrapper home-progress">
                                                <div className="modal__profile">

                                                    <div
                                                        className="w-100 d-flex align-self-center justify-content-between">
                                                        <div
                                                            className="d-flex align-self-center justify-content-center">
                                                            <div className="modal__icon">
                                                                <InstrumentIcon code={data?.bonus?.currency}/>
                                                            </div>
                                                            <div className="d-flex flex-column">
                                                                <span
                                                                    className="text-secondary">{data?.bonus?.name}</span>
                                                                <span
                                                                    className={`badge2 ${data?.is_active ? 'green' : 'red'}`}>{data?.is_active ? t('modals.vip.bonus.active') : t('modals.vip.bonus.passive')}</span>
                                                            </div>


                                                        </div>
                                                    </div>


                                                </div>

                                                <div className="modal__user my-3">
                                                    <span
                                                        className="text-secondary">{t('modals.vip.bonus.date')}: {moment.unix(data?.timestamp).format("MMM Do YY")}</span>
                                                    <span
                                                        className="text-secondary">{t('modals.vip.bonus.type')}: {StringHelper.capitalizeFirstLetter(data?.bonus?.model)}</span>
                                                </div>

                                                <div className="modal__user my-3">
                                                    <span className="text-secondary d-flex align-items-center gap-2">
                                                        <div className="d-flex align-items-center gap-2">
                                                            <InstrumentIcon code={data?.bonus?.currency}/>
                                                            {data?.bonus?.currency} →
                                                        </div>

                                                        {
                                                            data?.player_currency &&
                                                            <div className="d-flex align-items-center gap-2">
                                                                <InstrumentIcon code={data?.player_currency}/>
                                                                {data?.player_currency}
                                                            </div>
                                                        }

                                                    </span>

                                                </div>

                                                <div className="modal__user my-3">
                                                    {
                                                        data?.games?.map(game => (
                                                            <span
                                                                onClick={e =>
                                                                    handlePlayGame(data?.bonus?.currency, data?.player_currency, game)
                                                                }
                                                                className="tfactive cursor-pointer d-flex align-items-center gap-2"
                                                                key={game?.name}>
                                                                {game?.name}
                                                            </span>
                                                        ))
                                                    }

                                                </div>


                                            </div>
                                            :
                                            <div className="progress-wrapper home-progress">
                                                <div className="modal__profile">

                                                    <div
                                                        className="w-100 d-flex align-self-center justify-content-between">
                                                        <div
                                                            className="d-flex align-self-center justify-content-center">
                                                            <div className="modal__icon">
                                                                <InstrumentIcon code={data?.bonus?.currency}/>
                                                            </div>
                                                            <div className="d-flex flex-column">
                                                                <span
                                                                    className="text-secondary">{data?.bonus?.name}</span>
                                                                <span
                                                                    className={`badge2 ${data?.is_active ? 'green' : 'red'}`}>{data?.is_active ? t('modals.vip.bonus.active') : t('modals.vip.bonus.passive')}</span>
                                                            </div>
                                                        </div>


                                                        <div className="modal__user">
                                    <span
                                        className="text-secondary">{t('modals.vip.bonus.date')}: {moment.unix(data?.timestamp).format("MMM Do YY")}</span>
                                                            <span
                                                                className="text-secondary">{t('modals.vip.bonus.type')}: {StringHelper.capitalizeFirstLetter(data?.bonus?.model)}</span>
                                                            <span
                                                                className="text-secondary">{t('modals.vip.bonus.balance')}: {Big(data?.bonus?.balance || 0).toFixed(2)} {data?.bonus?.currency || ''}</span>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="modal__progress">
                                                    <div className="modal__progress-text">
                                                        <div>
                                                    <span
                                                        className="text-secondary">{t('modals.vip.bonus.amount')}: </span>
                                                            <span>{Big(data.amount || 0).toFixed(2)} {data?.bonus?.currency}</span>
                                                        </div>
                                                        <span>{Big(data?.percentage || 0).toFixed(2)}%</span>
                                                    </div>
                                                    <div className="modal__progress-bar">
                                                        <span style={{width: `${parseInt(data?.percentage || 0)}%`}}/>
                                                    </div>


                                                    <div
                                                        className="modal__progress-text modal__progress-text--white small">

                                                        <p className="d-flex align-items-center gap-2">
                                                    <span
                                                        className="text-secondary">{t('modals.vip.bonus.wager')}: </span>
                                                            {Big(data?.current || 0).toFixed(3)} {data?.bonus?.currency}
                                                        </p>


                                                        <p className="d-flex align-items-center gap-2">
                                                    <span
                                                        className="text-secondary">{t('modals.vip.bonus.required')}: </span>
                                                            {Big(data?.required || 0).toFixed(3)} {data?.bonus?.currency}
                                                        </p>


                                                    </div>
                                                </div>
                                            </div>

                            }
                        </div>

                    </div>
                </div>
            </div>
        </div>

    )
}


export default BonusModal
